import update from 'immutability-helper';
import React, { useMemo } from 'react';

import {
  Invite_InviteUserInput,
  InviteUserMutation,
  useInviteUserModalQuery,
  useInviteUserMutation,
  UserTableDocument,
  UserTableQuery
} from 'generated/graphql';
import { gqlCacheUtil } from 'modules/common';



export function useQuery(organizationId?: string) {

  const queryTuple = useInviteUserModalQuery({
    skip: !organizationId,
    variables: {
      organizationId: organizationId ?? ''
    }
  });

  return useMemo(() => {
    const seatCount = queryTuple.data?.subscriptionPlan?.seatCount ?? 0;
    const currentMembershipCount = queryTuple.data?.organization?.memberships.length ?? 0;
    return {
      ...queryTuple,
      data: {
        seatCount,
        currentMembershipCount,
        canInviteUser: !queryTuple.loading && (!organizationId || currentMembershipCount < seatCount)
      }
    };
  }, [
    organizationId,
    queryTuple
  ]);
}

export function useSendInvite() {
  const [
    fnMutate,
    tuple
  ] = useInviteUserMutation({
    updateQueries: gqlCacheUtil.genUpdateQueryMap<
      UserTableQuery,
      InviteUserMutation
    >(UserTableDocument, (prev, { mutationResult }) => {
      const user = mutationResult.data?.inviteUser;
      if (!user) {
        return prev;
      }

      return update(prev, {
        persons: {
          $push: [user.person]
        }
      });
    })
  });

  const fnWrappedMutate = React.useCallback(
    async (input: Invite_InviteUserInput) => {
      await fnMutate({
        variables: {
          input
        }

      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
